$(document).ready(function () {
  $(".js-select2").select2();

  toggleSalaryFields();

  $(".js-check-salary").on("change", function(){
    toggleSalaryFields();
  });
});

toggleSalaryFields = function () {
  const SALARY_TYPE_VALUES = {
    annual: [1, 2, 4],
    hourly: [3]
  };

  // 各給与タイプについて、チェックされているものがあるか確認
  Object.keys(SALARY_TYPE_VALUES).forEach(salaryType => {
    const values = SALARY_TYPE_VALUES[salaryType];
    const hasChecked = $(".js-check-salary").filter(function() {
      const value = parseInt($(this).val());
      return values.includes(value) && $(this).is(":checked");
    }).length > 0;

    const salaryFieldId = "#edit-profile-seeker-profile-field-kibou-kyuuyo-" + salaryType;
    $(salaryFieldId).toggle(hasChecked);
  });
}
